import { FaWhatsapp } from "react-icons/fa";
import { siteConfig } from "../data/siteConfig";

const WhatsAppButton = () => (
  <a
    className="whatsapp-float"
    href={`https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent("Hello USHA Resort! I have an enquiry.")}`}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
  >
    <FaWhatsapp />
  </a>
);

export default WhatsAppButton;